import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './ru.json';
import en from './en.json';
import { getCities } from '../actions/building';
import { store } from '..';
import { loadProfile } from '../actions/profile';

const savedLang = localStorage.getItem('lang') || 'ru';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      ru: {
        translation: ru,
      },
      en: {
        translation: en,
      },
    },
    lng: savedLang,
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('lang', lng);
  } catch (e) {
    console.warn('Could not save language to localStorage:', e);
  }

  const pathname = window.location.pathname;
  const excludeRoutes = ['/login'];

  const shouldSkip = excludeRoutes.some((route) => pathname.startsWith(route));

  if (!shouldSkip) {
    store.dispatch(getCities());
    store.dispatch(loadProfile());
  }
});

if (localStorage.getItem('debug') === '*') {
  document.addEventListener('keydown', (event) => {
    if (event.key === 'l') {
      i18n.changeLanguage(i18n.language === 'ru' ? 'en' : 'ru');
    }
  });
}

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js